/** Field-type metadata used by the builder UI. */
export const FIELD_TYPES = [
  { value: "text",         label: "Text",         help: "Single-line text" },
  { value: "long_text",    label: "Long Text",    help: "Multi-line paragraph" },
  { value: "email",        label: "Email",        help: "Validated email address" },
  { value: "mobile",       label: "Mobile",       help: "10-digit Indian mobile" },
  { value: "select",       label: "Dropdown",     help: "Choose one option" },
  { value: "multi_select", label: "Multi Select", help: "Choose multiple options" },
  { value: "yes_no",       label: "Yes / No",     help: "Boolean toggle" },
];

export const OPERATORS_FOR_TYPE = {
  text:         ["equals", "not_equals", "contains", "empty", "not_empty"],
  long_text:    ["equals", "not_equals", "contains", "empty", "not_empty"],
  email:        ["equals", "not_equals", "contains", "empty", "not_empty"],
  mobile:       ["equals", "not_equals", "contains", "empty", "not_empty"],
  select:       ["equals", "not_equals", "in", "empty", "not_empty"],
  multi_select: ["contains", "in", "empty", "not_empty"],
  yes_no:       ["is_true", "is_false", "empty", "not_empty"],
};

export const EFFECT_LABELS = {
  show:      "Show field",
  hide:      "Hide field",
  require:   "Make required",
  unrequire: "Make optional",
};

export function newId(prefix) {
  return `${prefix}_${Math.random().toString(36).slice(2, 10)}`;
}

export function evalCondition(operator, sourceValue, expected) {
  switch (operator) {
    case "equals":     return sourceValue === expected;
    case "not_equals": return sourceValue !== expected;
    case "contains":
      if (typeof sourceValue === "string" && typeof expected === "string")
        return sourceValue.toLowerCase().includes(expected.toLowerCase());
      if (Array.isArray(sourceValue)) return sourceValue.includes(expected);
      return false;
    case "in":
      return Array.isArray(expected) && expected.includes(sourceValue);
    case "is_true":
      return sourceValue === true || sourceValue === "yes" || sourceValue === "true";
    case "is_false":
      return sourceValue === false || sourceValue === "no" || sourceValue === "false";
    case "empty":
      return sourceValue == null || sourceValue === ""
        || (Array.isArray(sourceValue) && sourceValue.length === 0);
    case "not_empty":
      return !(sourceValue == null || sourceValue === ""
        || (Array.isArray(sourceValue) && sourceValue.length === 0));
    default: return false;
  }
}

/** Mirror of the backend resolver — returns
 *  { [fieldId]: { visible, required, field } } after applying all rules. */
export function resolveVisibility(definition, answers) {
  const state = {};
  const byId = {};
  for (const sec of definition.sections || []) {
    for (const f of sec.fields || []) {
      byId[f.id] = f;
      state[f.id] = { visible: true, required: !!f.required, field: f };
    }
  }
  for (const r of definition.rules || []) {
    const src = byId[r.source_field_id];
    const srcVal = src ? answers[src.key] : undefined;
    if (!evalCondition(r.operator, srcVal, r.value)) continue;
    for (const tid of r.target_field_ids || []) {
      const s = state[tid]; if (!s) continue;
      if (r.effect === "show")      s.visible = true;
      else if (r.effect === "hide") s.visible = false;
      else if (r.effect === "require")   s.required = true;
      else if (r.effect === "unrequire") s.required = false;
    }
  }
  for (const fid of Object.keys(state)) {
    if (!state[fid].visible) state[fid].required = false;
  }
  return state;
}
